/**
 * @generated SignedSource<<e83567e170c08c9561f374effe851103>>
 * @relayHash eea1a109b20ca170ba7c72498a1d10ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50e30b6e010117b3321277df67b9d32c843683e4ffa5a4b6f4409e228d6f74c7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthEditionAwarenessStandardTrialOverview_TenantSubscriptionQuery } from './uiGrowthEditionAwarenessStandardTrialOverview_TenantSubscriptionQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthEditionAwarenessStandardTrialOverview_TenantSubscriptionQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "50e30b6e010117b3321277df67b9d32c843683e4ffa5a4b6f4409e228d6f74c7",
    "metadata": {},
    "name": "uiGrowthEditionAwarenessStandardTrialOverview_TenantSubscriptionQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
